/*
 *******************************************************************************
 *
 *  Filename:   @/contexts/shared/constants.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Constants for contexts.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Saturday, August 19, 2023 - 10:00 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/19  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const INITIALIZE = "INITIALIZE";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_UP = "SIGN_UP";
export const SAVE_EMAIL = "SAVE_EMAIL";
export const NEW_PASSWORD = "NEW_PASSWORD";
